import { render, staticRenderFns } from "./jjfz_list.vue?vue&type=template&id=12e164a6&scoped=true"
import script from "./jjfz_list.vue?vue&type=script&lang=js"
export * from "./jjfz_list.vue?vue&type=script&lang=js"
import style0 from "./jjfz_list.vue?vue&type=style&index=0&id=12e164a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e164a6",
  null
  
)

export default component.exports